export enum FieldStatusEnum {
    Editable = 0,
    Readonly = 1,
    Hidden = 2
}
